import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { useStockReportContext } from 'src/contexts/stock-report.context'

export const AnalystForecast: React.FC = () => {
  const { report } = useStockReportContext()

  return (
    <>
      <SectionHeader spacing={3}>Analyst Forecast</SectionHeader>
      <div style={{ overflowX: 'auto' }}>
        <table className={'stk-table-stretched'} style={{ minWidth: '500px' }}>
          <thead>
            <tr>
              <th>
                Price target <ValueLocked />
                <div>
                  (<ValueLocked /> price)
                </div>
              </th>
              <th colSpan={3}>{report.analystForecast.firstEstimateDate}</th>
              <th colSpan={3}>{report.analystForecast.secondEstimateDate}</th>
            </tr>
            <tr>
              <th>
                Est. Long Term Growth Rate: <ValueLocked />
              </th>
              <th>
                Net Profit
                <div>
                  (<ValueLocked />)
                </div>
              </th>
              <th>
                EPS
                <div>
                  (<ValueLocked />)
                </div>
              </th>
              <th>
                DPS
                <div>
                  (<ValueLocked />)
                </div>
              </th>
              <th>
                Net Profit
                <div>
                  (<ValueLocked />)
                </div>
              </th>
              <th>
                EPS
                <div>
                  (<ValueLocked />)
                </div>
              </th>
              <th>
                DPS
                <div>
                  (<ValueLocked />)
                </div>
              </th>
            </tr>
            {buildHeaderDataRow('Consensus Estimate')}
          </thead>
          <tbody>
            {buildDataRow('1m Change')}
            {buildDataRow('3m Change')}
          </tbody>
        </table>
      </div>
    </>
  )
}

function buildHeaderDataRow(label: string) {
  return (
    <tr>
      <th className={'stk-text-align-r'}>{label}</th>
      <th aria-label="Subscribe to view">
        <ValueLocked />
      </th>
      <th aria-label="Subscribe to view">
        <ValueLocked />
      </th>
      <th aria-label="Subscribe to view">
        <ValueLocked />
      </th>
      <th aria-label="Subscribe to view">
        <ValueLocked />
      </th>
      <th aria-label="Subscribe to view">
        <ValueLocked />
      </th>
      <th aria-label="Subscribe to view">
        <ValueLocked />
      </th>
    </tr>
  )
}

function buildDataRow(label: string) {
  return (
    <tr>
      <td className={'stk-text-align-r'}>{label}</td>
      <td>
        <ValueLocked />
      </td>
      <td>
        <ValueLocked />
      </td>
      <td>
        <ValueLocked />
      </td>
      <td>
        <ValueLocked />
      </td>
      <td>
        <ValueLocked />
      </td>
      <td>
        <ValueLocked />
      </td>
    </tr>
  )
}
